//src/components/icons/index.ts

export { default as IconAddFriend } from './AddFriendIcon';
export { default as IconAddFriendOutline } from './AddFriendOutlineIcon';
export { default as IconAdd } from './AddIcon';
export { default as IconAddPost } from './AddPostIcon';
export { default as IconAddSolid } from './AddSolidIcon';
export { default as IconAiFace } from './AiFaceIcon';
export { default as IconAnalyze } from './AnalyzeIcon';
export { default as IconArFill } from './ArFillIcon';
export { default as IconAR } from './ARIcon';
export { default as IconArrow } from './ArrowIcon';
export { default as IconArrowSolid } from './ArrowSolidIcon';
export { default as IconArSpaceOutline } from './ArSpaceOutlineIcon';
export { default as IconAvatarSolid } from './AvatarSolidIcon';
export { default as IconBackArrow } from './BackArrowIcon';
export { default as IconBell } from './BellIcon';
export { default as IconBlockOutline } from './BlockOutlineIcon';
export { default as IconCancel } from './CancelIcon';
export { default as IconCart } from './CartIcon';
export { default as IconCartOutline } from './CartOutlineIcon';
export { default as IconChatFriend } from './ChatFriendIcon';
export { default as IconChat } from './ChatIcon';
export { default as IconChatOutline } from './ChatOutlineIcon';
export { default as IconCheckBadge } from './CheckBadgeIcon';
export { default as IconCheckDouble } from './CheckDoubleIcon';
export { default as IconCheck } from './CheckIcon';
export { default as IconCloak } from './CloakIcon';
export { default as IconCloseSolid } from './CloseSolidIcon';
export { default as IconCoinEmoji } from './CoinEmojiIcon';
export { default as IconCoinOutline } from './CoinOutlineIcon';
export { default as IconCollectCoin } from './CollectCoinIcon';
export { default as IconCompass } from './CompassIcon';
export { default as IconCopyLinkFill } from './CopyLinkFillIcon';
export { default as IconDelete } from './DeleteIcon';
export { default as IconDraw } from './DrawIcon';
export { default as IconEditOutline } from './EditOutlineIcon';
export { default as IconEmailColor } from './EmailColorIcon';
export { default as IconEmojiHeart } from './EmojiHeartIcon';
export { default as IconEmojiOutline } from './EmojiOutlineIcon';
export { default as IconExchangeCoin } from './ExchangeCoinIcon';
export { default as IconExchange } from './ExchangeIcon';
export { default as IconExclamationMarkCircle } from './ExclamationMarkCircleIcon';
export { default as IconFacebookColor } from './FacebookColorIcon';
export { default as IconFavorOutline } from './FavorOutlineIcon';
export { default as IconFavorSolid } from './FavorSolidIcon';
export { default as IconFilter } from './FilterIcon';
export { default as IconFluentMoneyOutline } from './FluentMoneyOutlineIcon';
export { default as IconFriends } from './FriendIcon';
export { default as IconFriendsList } from './FriendsListIcon';
export { default as IconFullscreen } from './FullscreenIcon';
export { default as IconGenderFemale } from './GenderFemaleIcon';
export { default as IconGenderMale } from './GenderMaleIcon';
export { default as IconGetBoxOutline } from './GetBoxOutlineIcon';
export { default as IconGift } from './GiftIcon';
export { default as IconGiftOutline } from './GiftOutlineIcon';
export { default as IconGiftSolid } from './GiftSolidIcon';
export { default as IconGiveCoin } from './GiveCoinIcon';
export { default as IconGlobalOutline } from './GlobalOutlineIcon';
export { default as IconGlobalSquare } from './GlobalSquareIcon';
export { default as IconGridView } from './GridViewIcon';
export { default as IconGroupTogether } from './GroupTogetherIcon';
export { default as IconGuideOutline } from './GuideOutlineIcon';
export { default as IconHelpCircleOutline } from './HelpCircleOutlineIcon';
export { default as IconHelpOutline } from './HelpOutlineIcon';
export { default as IconHot } from './HotIcon';
export { default as IconIncome } from './IncomeIcon';
export { default as IconLineColor } from './LineColorIcon';
export { default as IconListView } from './ListViewIcon';
export { default as IconLocation } from './LocationIcon';
export { default as IconLock } from './LockIcon';
export { default as IconLockOutline } from './LockOutlineIcon';
export { default as IconLogin } from './LoginIcon';
export { default as IconLogout } from './LogoutIcon';
export { default as IconLogOutOutline } from './LogOutOutlineIcon';
export { default as IconLottery } from './LotteryIcon';
export { default as IconLoveBox } from './LoveBoxIcon';
export { default as IconLove } from './LoveIcon';
export { default as IconLucidePlus } from './LucidePlusIcon';
export { default as IconMail } from './MailIcon';
export { default as IconMember } from './MemberIcon';
export { default as IconMenu } from './MenuIcon';
export { default as IconMicrophone } from './MicrophoneIcon';
export { default as IconMood } from './MoodIcon';
export { default as IconMoreCircleOutline } from './MoreCircleOutlineIcon';
export { default as IconMoreHorizontalOutline } from './MoreHorizontalOutlineIcon';
export { default as IconMore } from './MoreIcon';
export { default as IconMoreImage } from './MoreImageIcon';
export { default as IconNote } from './NoteIcon';
export { default as IconNull } from './NullIcon';
export { default as IconPepiconsPrintGift } from './PepiconsPrintGiftIcon';
export { default as IconPhone } from './PhoneIcon';
export { default as IconPhoto } from './PhotoIcon';
export { default as IconQRcode } from './QRcodeIcon';
export { default as IconRankOutline } from './RankOutlineIcon';
export { default as IconRecordHistoryOutline } from './RecordHistoryOutlineIcon';
export { default as IconReportOutline } from './ReportOutlineIcon';
export { default as IconScan } from './ScanIcon';
export { default as IconSearch } from './SearchIcon';
export { default as IconSell } from './SellIcon';
export { default as IconSend } from './SendIcon';
export { default as IconSetting } from './SettingIcon';
export { default as IconShare } from './ShareIcon';
export { default as IconShareOutline } from './ShareOutlineIcon';
export { default as IconShareOutline2 } from './ShareOutlineIcon2';
export { default as IconShareSolid } from './ShareSolidIcon';
export { default as IconShield } from './ShieldIcon';
export { default as IconShow } from './ShowIcon';
export { default as IconSortDown } from './SortDownIcon';
export { default as IconSortOutline } from './SortOutlineIcon';
export { default as IconSortUp } from './SortUpIcon';
export { default as IconSticky } from './StickyIcon';
export { default as IconStore } from './StoreIcon';
export { default as IconUserGroup } from './UserGroupIcon';
export { default as IconUser } from './UserIcon';
export { default as IconUserProfile } from './UserProfileIcon';
export { default as IconVideo } from './VideoIcon';
export { default as IconView } from './ViewIcon';
export { default as IconViewOff } from './ViewOffIcon';
export { default as IconViewSolid } from './ViewSolidIcon';
export { default as IconWallet } from './WalletIcon';
export { default as IconWarningOutline } from './WarningOutlineIcon';
export { default as IconWishCandle } from './WishCandleIcon';
export { default as IconYoutube } from './YoutubeIcon';
export { default as IconSharePark } from './ShareParkIcon';
export { default as IconRecommend } from './RecommendIcon';
export { default as IconShareHuge } from './ShareHugeIcon';
export {
  IconFB,
  IconIG,
  IconYT,
  IconLine,
  IconLineSquare,
  IconApple,
  IconTikTok,
} from './SocialMediaIcon';
export { default as IconRoundStore } from './RoundStoreIcon';
export { default as IconGoogleMap } from './GoogleMapIcon';
export { default as IconClockOutline } from './ClockOutlineIcon';
export { default as IconAdvertise } from './AdvertiseIcon';
export { default as IconGroupMarketing } from './GroupMarketingIcon';
export { default as IconDashboard } from './DashboardIcon';
export { default as IconEgg } from './EggIcon';
export { default as IconText } from './TextIcon';
